import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import GlobalVariables from './GlobalVariables';

class ScrollToTopOnRoute extends Component {
  constructor(props) {
    super(props);
    //console.log(props);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.path === this.props.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;
    
    /*
    console.log(this.props);
    console.log(typeof Component);
    console.log(Component);
    console.log(this.props.targetComponent);
    */
    
    if(this.props.isSetLang){
      GlobalVariables.currentLang = this.props.lang;
      GlobalVariables.currentPagepath = this.props.pagepath;
      return <Route {...rest} render={props => (<Component {...props} lang={ this.props.lang } key={this.props.path} />)} />;
    }
    else{
      GlobalVariables.currentLang = 'tc';
      GlobalVariables.currentPagepath = this.props.pagepath;
      return <Route {...rest} render={props => (<Component {...props} key={this.props.path} />)} />;
    }
  }
}

export default withRouter(ScrollToTopOnRoute);


// WEBPACK FOOTER //
// ./src/components/ScrollToTopOnRoute.js